import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import './transparencia.css';

import { transparencia_item } from '../../json/transparenciaItem';

const iconos = [
  'fa-folder-open',
  'fa-clock-rotate-left',
  'fa-hand-holding-dollar',
  'fa-building-columns',
];

const descripciones = [
  'Consulta la información de los 48 rubros de transparencia.',
  'Consulta información histórica de los rubros de transparencia.',
  'Consulta la información del recurso federal 1 y 5 al millar.',
  'Consulta la información del recurso estatal 5 al millar.',
];

const Transparencia = ({ name, data }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="transparencia-page">
      <div className="container transparencia-container container-mh">
        <div className="row">
          <div className="col-12">
            <div className="transparencia-heading">
              <h1 className="title">Transparencia</h1>
              <span className="transparencia-heading-line" />
            </div>
          </div>
        </div>

        <div className="row transparencia-cards-row">
          {transparencia_item.map((item, index) => (
            <div
              key={index}
              className="col-lg-4 col-md-6 col-12 transparencia_item"
            >
              <Link
                to={item.transparencia_item_url}
                className="text-decoration-none w-100 d-block"
              >
                <article className="transparencia-card">
                  <div className="transparencia-card-icon">
                    <i
                      className={`fa-solid ${
                        iconos[index] || 'fa-file-circle-info'
                      }`}
                    />
                  </div>

                  <div className="transparencia-card-content">
                    <h2>{item.transparencia_item_nombre}</h2>
                    <p>
                      {descripciones[index] ||
                        'Consulta la información disponible en este apartado.'}
                    </p>
                  </div>

                  <div className="transparencia-card-arrow">
                    <i className="fa-solid fa-chevron-right" />
                  </div>
                </article>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
};

export default Transparencia;